import { useState, useCallback, Suspense, lazy, useEffect } from "react";
import { Notification, useLocale } from "react-admin";
import PropTypes from "prop-types";
// Providers
import themeApp from "../providers/themeProvider";
import themeConfig from "../config/index";
// Components
import {
  Paper,
  Box,
  makeStyles,
  ThemeProvider,
  Hidden,
} from "@material-ui/core";
import { useCheckForApplicationUpdate } from "../hooks/useCheckForApplicationUpdate";
import { LoaderView } from "../components/layout/LoaderView";
import { LoaderApp } from "../components/layout/LoaderApp";
import { GlobalDataProvider } from "../context/GlobalDataProvider";
import {lazyRetry} from '../utils/index';
import { AppProvider } from "../context/AppProvider";
const Sidebar = lazy(() => lazyRetry(() => import("../components/layout/Sidebar")));
const Navbar = lazy(() => lazyRetry(() => import("../components/layout/Navbar")));
const themeConfig2 = require("../config/index").default;
const themeFavicon =
  require(`../assets/images/${themeConfig2.companyFavicon}`).default;


const useStyles = makeStyles((theme) => ({
  bg: {
    background: themeConfig.companySidebarColor,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  paper: {
    width: "100vw",
    height: "100vh",
    borderRadius: "47px 0 0 47px",
    backgroundColor: "#fff",
    boxShadow: "0px 0px 10px 8px rgb(0 0 0 / 0.08)",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      borderRadius: 0,
    },
  },
  content: {
    padding: "0 40px",
    margin: "20px 0",
    [theme.breakpoints.down("xs")]: {
      padding: "0 15px",
    },
  },
}));

function AppLayout({ children }) {
  const classes = useStyles();
  const locale = useLocale();
  //useCheckForApplicationUpdate({ onNewVersionAvailable: () => console.log("Nueva versión"), disabled: false });
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = useCallback(
    () => setMobileOpen(!mobileOpen),
    [mobileOpen]
  );

  useEffect(() => {
    document.title = themeConfig.companyName.includes("Soldi")
      ? "Soldi Backoffice"
      : locale === "en"
        ? `Welcome to ${themeConfig.companyName}`
        : `Bienvenido a ${themeConfig.companyName}`;

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = themeFavicon;
  }, [locale]);
  return (
    <ThemeProvider theme={themeApp}>
      <Suspense fallback={<LoaderApp />}>
        <AppProvider>
          <GlobalDataProvider>
            <Box display="flex" className={classes.bg}>
              <Hidden mdUp>
                <Sidebar
                  mobileOpen={mobileOpen}
                  handleDrawerToggle={handleDrawerToggle}
                  variant={true}
                />
              </Hidden>
              <Hidden mdDown>
                <Sidebar mobileOpen={false} variant={false} />
              </Hidden>
              <Suspense
                fallback={
                  <Paper className={classes.paper}>
                    <Navbar handleDrawerToggle={handleDrawerToggle} />
                    <Box
                      height="100%"
                      margin={0}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      component="main"
                    >
                      <LoaderView />
                    </Box>
                  </Paper>
                }
              >
                <Paper className={classes.paper}>
                  <Navbar handleDrawerToggle={handleDrawerToggle} />
                  <Box margin={0} className={classes.content} component="main">
                    {children}
                  </Box>
                </Paper>
              </Suspense>
            </Box>
          </GlobalDataProvider>
        </AppProvider>
      </Suspense>
      <Notification autoHideDuration={2500} />
    </ThemeProvider>
  );
}

AppLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  title: PropTypes.string.isRequired,
};

export { AppLayout };
